import React, { useState } from 'react';
import {Container, Dimmer, Table, Card,Button, Page} from "tabler-react";
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const faqs = records?.settings?.FAQ || [];
  const filteredFaqs = searchQuery
    ? faqs.filter(({ question, answer }) =>
        `${question} ${answer}`.toLowerCase().includes(searchQuery.toLowerCase()))
    : faqs;

  return (
    <Container>
      <Page.Header>
        <Page.Title>FAQ</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer
          active={loading}
          loader={loading}
        >
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={setSearchQuery} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('faq-create', null, reload)}
              >
                Create FAQ
              </Button>
            </Card.Options>
          </Card.Header>
          {!loading && filteredFaqs.length < 1 ?
            <div className="alert alert-primary m-0">
              No FAQ to show!
            </div>
            :
            <Table
              hasOutline
              striped
            >
              <Table.Header>
                {headers.map((head, i) => (
                  <Table.ColHeader
                    key={`tableHeader-${i}`}
                  >
                    {head}
                  </Table.ColHeader>
                ))}
                <Table.ColHeader>Actions</Table.ColHeader>
              </Table.Header>
              <Table.Body>

                {filteredFaqs.map((r, i) => (
                  <Table.Row key={i}>
                    {Object.keys(r).map((k, i) => {
                      if (k === 'question') {
                        return (<Table.Col>
                          <p>{r['question']}</p>
                        </Table.Col>);
                      } else if (k === 'answer') {
                        return (<Table.Col>
                          <p>{r['answer']}</p>
                        </Table.Col>);
                      }
                      return null;
                    })}
                    <Table.Col>
                      <Button
                        outline
                        color="secondary"
                        icon=""
                        size="sm"
                        onClick={() => openMainModal('faq-edit', r['_id'], reload)}
                      >
                        Edit
                      </Button>

                      <Button
                        outline
                        color="danger"
                        icon=""
                        className="ml-2 mr-2"
                        size="sm"
                        onClick={() => openMainModal('settings/FAQ--delete', r['_id'], reload)}
                      >
                        Delete
                      </Button>
                    </Table.Col>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          }
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;